import { render, staticRenderFns } from "./SubjectInformationTable.vue?vue&type=template&id=47598938&"
import script from "./SubjectInformationTable.vue?vue&type=script&lang=js&"
export * from "./SubjectInformationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports